import { useMemo } from "react";
import {
  ContractorCardLoadingState,
  MutationsObject,
  QueriesObject,
} from "../context/ContractorCardContext";

export const useContractorCardLoading = (
  queries: QueriesObject,
  mutations: MutationsObject,
): ContractorCardLoadingState => {
  return useMemo(() => {
    const { isFetching, isLoading } = queries.contractorCardQuery;

    if (isFetching || isLoading)
      return { isLoading: true, reason: "fetching_contractor_card" };
    if (mutations.updateContractorCardMutation.isPending)
      return { isLoading: true, reason: "updating_contractor_card" };
    return { isLoading: false, reason: "unknown" };
  }, [
    queries.contractorCardQuery,
    mutations.updateContractorCardMutation.isPending,
  ]);
};
